import React from 'react';
import Layout from '../components/Layout/Layout';

/**
 * @component for home page
 * This is an empty view that renders as a fall through
 * for company or individual users
 */
const Home: React.FC = () => {
  return <Layout />;
};

export default Home;
